import { useLocation } from 'react-router-dom';

import { useSearchContext } from '@atlas/core';

import { MIN_SEARCH_STRING_LENGTH, searchQuerySymbol } from 'common/constants';

export const useSearch = () => {
  const { search } = useLocation();
  const { events, tournaments } = useSearchContext();

  const searchParams = new URLSearchParams(search);
  const searchString = searchParams.get(searchQuerySymbol) || '';

  const searchStringLength = searchString.length;
  const isValidPrompt = searchStringLength >= MIN_SEARCH_STRING_LENGTH;

  const resultLength = events.length + tournaments.length;

  return {
    isValidPrompt,
    resultLength,
    searchString,
  };
};
